import styled from "styled-components";

export const ScrollableContainerDiv = styled.div<{ $height: number; $paddingTop?: number }>`
  width: 100%;
  overflow-y: scroll;
  padding-top: ${(props) => (props.$paddingTop !== undefined ? `${props.$paddingTop}px` : `0px`)};
  height: ${(props) => props.$height}px;
`;
